import React from 'react';
import { useParams } from 'react-router-dom';
import ContainerComponent from '../../helpers/components/container.component';
import PassLayout from './components/pass_layout';

const PassIndex = () => {
    const { pass_code } = useParams();

    return (
        <>
            <div className='ticket-detail-wrapper'>
                <ContainerComponent span={14} top={20} bottom={20}>
                    <PassLayout pass_code={pass_code} />
                </ContainerComponent>
            </div>
        </>
    );
}

export default PassIndex;
